import { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch } from "react-redux";

//MUI
import {
  Button,
  IconButton,
  Popper,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Checkbox,
  Divider,
  Typography,
  Box,
  Grid,
  Fade,
  Paper,
  Slide,
  Tooltip,
} from "@mui/material";

//icons
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
// import HistoryIcon from "@mui/icons-material/History";
import PrintIcon from "@mui/icons-material/Print";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import TuneIcon from "@mui/icons-material/Tune";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import EmailIcon from "@mui/icons-material/Email";

//Redux
import * as actionTypes from "../../state/actionTypes";

//components
import SelectedMessagesPrint from "./SelectedMessagesPrint";
import MessageIcons from "./MessageIcons";
import MailModal from "../MailModal";

//Helpers
import { getAllIcons } from "../../../../utils/messageIcons";

//Third party
// import JsPDF from "jspdf";
// import html2canvas from "html2canvas";
import { useReactToPrint } from "react-to-print";

/**
 *
 * @param {Array} messages Array of messages
 * @returns
 */
const SelectedMessages = ({
  messages,
  currentType,
  currentMessageStatus,
  currentReferenceNumber,
  success,
  error,
}) => {
  const [icons, setIcons] = useState({});
  //constants
  const categories = useMemo(
    () => [
      // "MESSAGE STATUS",
      ...(currentMessageStatus === "To Swift" ? ["GENERATION TYPE"] : []),
      "ROUTING",
      ...(["103", "199", "202", "205", "299"].includes(currentType)
        ? ["GPI STATUS"]
        : []),
      "NATIONAL/INTERNATIONAL",
      ...(["103", "102", "104", "107", "101", "740"].includes(currentType)
        ? ["CHARGES"]
        : []),
    ],
    [currentMessageStatus, currentType]
  );
  const initialFilters = useMemo(
    () => [
      // {
      //   id: "ACK",
      //   categoryLabel: "MESSAGE STATUS",
      //   category: "messageStatus",
      //   label: "ACK",
      //   value: "ACK",
      //   icon: icons.ACK,
      // },
      // {
      //   id: "NACK",
      //   categoryLabel: "MESSAGE STATUS",
      //   category: "messageStatus",
      //   label: "NACK",
      //   value: "NACK",
      //   icon: icons.NACK,
      // },
      ...(currentMessageStatus === "To Swift"
        ? [
            {
              id: "System Recieved",
              categoryLabel: "GENERATION TYPE",
              category: "generationType",
              label: "System Generated",
              value: "RECEIVED",
              icon: icons.systemRecievedIcon,
            },
            {
              id: "Automatic Generation",
              categoryLabel: "GENERATION TYPE",
              category: "generationType",
              label: "Automatic Generation",
              value: "AUTOMATIC",
              icon: icons.autoGeneratedIcon,
            },
            {
              id: "Manual Generation",
              categoryLabel: "GENERATION TYPE",
              category: "generationType",
              label: "Manual Generation",
              value: "MANUAL",
              icon: icons.manualGeneratedIcon,
            },
          ]
        : []),
      {
        id: "SAA",
        categoryLabel: "ROUTING",
        category: "routingType",
        label: "SAA",
        value: "SAA",
        icon: icons.SAA,
      },

      {
        id: "AML Passed",
        categoryLabel: "ROUTING",
        category: "routingType",
        label: "AML Passed",
        value: "AML_PASSED",
        icon: icons.AML_PASSED,
      },
      {
        id: "AML Rejected",
        categoryLabel: "ROUTING",
        category: "routingType",
        label: "AML Rejected",
        value: "AML_REJECTED",
        icon: icons.AML_REJECTED,
      },
      {
        id: "AML Pending",
        categoryLabel: "ROUTING",
        category: "routingType",
        label: "AML Pending",
        value: "AML_PENDING",
        icon: icons.AML_PENDING,
      },

      {
        id: "NATIONAL TRANSACTION",
        categoryLabel: "NATIONAL/INTERNATIONAL",
        category: "state",
        label: "NATIONAL TRANSACTION",
        value: "NATIONAL",
        icon: icons.NATIONAL,
      },
      {
        id: "INTERNATIONAL TRANSACTION",
        categoryLabel: "NATIONAL/INTERNATIONAL",
        category: "state",
        label: "INTERNATIONAL TRANSACTION",
        value: "INTERNATIONAL",
        icon: icons.INTERNATIONAL,
      },
      ...(["103", "199", "202", "205", "299"].includes(currentType)
        ? [
            {
              id: "ACCC",
              categoryLabel: "GPI STATUS",
              category: "gpiStatus",
              label: "ACCC",
              value: "ACCC",
              icon: icons.ACCC,
            },

            {
              id: "ACSP",
              categoryLabel: "GPI STATUS",
              category: "gpiStatus",
              label: "ACSP",
              value: "ACSP",
              icon: icons.ACSP,
            },
            {
              id: "RJCT",
              categoryLabel: "GPI STATUS",
              category: "gpiStatus",
              label: "RJCT",
              value: "RJCT",
              icon: icons.RJCT,
            },
          ]
        : []),

      ...(["103", "102", "104", "107", "101", "740"].includes(currentType)
        ? [
            {
              id: "OUR",
              categoryLabel: "CHARGES",
              category: "chargeMessage",
              label: "OUR",
              value: "OUR",
              icon: icons.OUR,
            },
            {
              id: "BEN",
              categoryLabel: "CHARGES",
              category: "chargeMessage",
              label: "BEN",
              value: "BEN",
              icon: icons.BEN,
            },
            {
              id: "SHA",
              categoryLabel: "CHARGES",
              category: "chargeMessage",
              label: "SHA",
              value: "SHA",
              icon: icons.SHA,
            },
          ]
        : []),
    ],
    [currentMessageStatus, currentType, icons]
  );

  const dispatch = useDispatch();

  //Selected messages states
  const [checked, setChecked] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  //printing states
  const SelectedMessagesPrintRef = useRef(null);
  const onBeforeGetContentRef = useRef(); //a ref for a promise resolve
  const [isPrinting, setIsPrinting] = useState(false);

  //messages filters states
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [checkedFilters, setCheckedFilters] = useState([]);
  const [filters, setFilters] = useState(initialFilters);
  const [searchFilters, setSearchFilters] = useState("");
  const searchFiltersRef = useRef(null);

  const [isMailModalOpen, setIsMailModalOpen] = useState(false);

  //Handlers
  //filters menu handlers
  const handleToggleFilters = (event) => {
    setAnchorEl(event.currentTarget);
    setIsFiltersOpen(!isFiltersOpen);
  };

  const handleToggleFilter = (e) => {
    const currentIndex = checkedFilters.findIndex(
      (filter) => filter.id === e.target.id
    );

    let newChecked = [...checkedFilters];

    if (currentIndex === -1) {
      const newFilter = filters.find((filter) => filter.id === e.target.id);
      // const category = newFilter.category;
      // newChecked = newChecked.filter((filter) => filter.category !== category);
      newChecked.push(newFilter);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setCheckedFilters(newChecked);

    dispatch({
      type: actionTypes.FILTER_CURRENT_TYPE_MESSAGES,
      payload: newChecked,
    });
  };

  const handleSearchFilters = (e) => {
    e.preventDefault();

    const search = e.target.value.toLocaleLowerCase();
    setSearchFilters(search);

    if (!search) {
      setFilters(initialFilters);
    } else {
      const filteredFilters = initialFilters.filter((filter) =>
        filter.label.toLocaleLowerCase().includes(search)
      );

      setFilters(filteredFilters);
    }
  };

  const clearAllFilters = () => {
    setCheckedFilters([]);
    dispatch({
      type: actionTypes.FILTER_CURRENT_TYPE_MESSAGES,
      payload: [],
    });
  };

  //print and export handlers
  //before get content to print handler (returns a promise so the print preview dialoge waits for the state of 'printing' to finish updating)
  const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => {
      setIsPrinting(true); //set printing state to true (a dependency for hidden and shown content in the print[])
      onBeforeGetContentRef.current = resolve; //to resolve the promise right after the printing state is updated
    });
  };

  const handlePrint = useReactToPrint({
    content: () => SelectedMessagesPrintRef.current,
    documentTitle: "ORCHESTRO SWIFT DAY MESSAGES",
    onBeforeGetContent: handleOnBeforeGetContent,

    onAfterPrint: () => setIsPrinting(false),
  });

  // const handleExport = useReactToPrint({
  //   content: () => SelectedMessagesPrintRef.current,
  //   documentTitle: "CORZAP SWIFT DAY MESSAGES",
  //   onBeforeGetContent: handleOnBeforeGetContent,

  //   onAfterPrint: () => {
  //     setIsPrinting(false);
  //   },

  //   print: async (printIframe) => {
  //     const doc = printIframe.contentWindow.document;
  //     const elementsToHide = doc.querySelectorAll(".hide-in-export");
  //     elementsToHide.forEach((element) => {
  //       element.style.display = "none";
  //     });

  //     const messagesToExport = doc.querySelectorAll(".message");

  //     const pdf = new JsPDF({
  //       orientation: "a4",
  //       unit: "px",
  //       format: [2508, 2480],
  //     });

  //     messagesToExport.forEach((message, index) => {
  //       html2canvas(message).then((canvas) => {
  //         const base64Image = canvas.toDataURL("image/png");
  //         pdf.addImage(base64Image, "PNG", 15, 15, 2400, 2400);

  //         if (index === messagesToExport.length - 1)
  //           pdf.save("corzap-messages.pdf");
  //         else pdf.addPage();
  //       });
  //     });
  //   },
  // });

  //Message selection handlers
  const handleToggle = (e) => {
    const currentIndex = checked.findIndex(
      (message) => message.header.referenceNumber === e.target.id
    );

    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(
        messages.find(
          (message) => message.header.referenceNumber === e.target.id
        )
      );
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleSelect = (e) => {
    dispatch({
      type: actionTypes.SET_CURRENT_MESSAGE,
      payload: e.currentTarget.id,
    });
  };

  const SelectAllHandler = () => {
    if (checked.length) {
      setSelectAll(false);
      setChecked([]);
    } else {
      setSelectAll(true);
      setChecked([...messages]);
    }
  };

  useEffect(() => {
    if (checked.length) setSelectAll(true);
    else setSelectAll(false);
  }, [checked.length]);

  //resolve onBeforeGetContent promise right after printing state is updated
  useEffect(() => {
    if (isPrinting) onBeforeGetContentRef.current();
  }, [isPrinting, onBeforeGetContentRef]);

  //import filters' icons
  useEffect(() => {
    if (isFiltersOpen && !Object.keys(icons).length) {
      getAllIcons().then((allIcons) => setIcons(allIcons));
    }
  }, [icons, isFiltersOpen]);

  //return all states to initial on changing selected type (when 'currentType' prop changes)
  useEffect(() => {
    setChecked([]);
    setSelectAll(false);

    setIsPrinting(false);

    //messages filters states
    setIsFiltersOpen(false);
    setAnchorEl(null);
    setCheckedFilters([]);
    setFilters(initialFilters);
    setSearchFilters("");
  }, [currentType, initialFilters]);

  return (
    <div
      style={{
        minHeight: "100%",
        borderRight: "1px solid #CFD7DF",
        width: "100%",
        backgroundColor: "#F8FAFB",
      }}
    >
      <Box sx={{ display: "none" }}>
        <SelectedMessagesPrint
          ref={SelectedMessagesPrintRef}
          messages={isPrinting ? checked : []}
        />
      </Box>

      {isMailModalOpen && (
        <MailModal
          handleClose={() => setIsMailModalOpen(false)}
          referenceNumbers={checked.map((mess) => mess.header.referenceNumber)}
          success={success}
          error={error}
        />
      )}

      <List
        sx={{
          width: "100%",
          minHeight: "100%",
          backgroundColor: "#F8FAFB",
        }}
        disablePadding
      >
        {!messages ? (
          <Typography
            sx={{
              margin: "auto",
              width: "40%",
              paddingTop: "20%",
              color: "#50566E",
              fontWeight: 550,
              fontSize: ".875rem",
              opacity: 0.85,
            }}
          >
            No folder selected
          </Typography>
        ) : (
          <>
            <ListItem disablePadding sx={{ width: "100%" }}>
              <ListItemButton
                role={undefined}
                dense
                sx={{
                  maxHeight: "48px",
                  height: "48px",
                  width: "100%",
                  backgroundColor: "#F8FAFB",
                  paddingLeft: "22px",
                }}
                disableRipple
              >
                <Checkbox
                  edge="start"
                  checked={selectAll}
                  onClick={SelectAllHandler}
                  checkedIcon={<IndeterminateCheckBoxIcon />}
                  tabIndex={-1}
                  disableRipple
                  size="small"
                  sx={{
                    "&.Mui-checked": {
                      color: "#1492AF",
                    },
                  }}
                />
                {checked.length ? (
                  <>
                    <ListItemText>
                      <Typography
                        sx={{
                          color: "#50566E",
                          fontSize: "14px",
                          lineHeight: "16px",
                          width: "266px",
                        }}
                      >
                        {checked.length} Selected
                      </Typography>
                    </ListItemText>

                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                        paddingLeft: "5px",
                      }}
                    >
                      <Tooltip title="email">
                        <IconButton
                          sx={{
                            background:
                              "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                            borderRadius: "5px",
                            color: "#050D2E",
                            border: "1px solid #CFD7DF",
                          }}
                          variant="solid"
                          size="small"
                          onClick={() => setIsMailModalOpen(true)}
                        >
                          <EmailIcon fontSize="20px" />
                        </IconButton>
                      </Tooltip>
                      <IconButton
                        sx={{
                          background:
                            "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                          borderRadius: "5px",
                          color: "#050D2E",
                          border: "1px solid #CFD7DF",
                        }}
                        variant="solid"
                        size="small"
                        onClick={handlePrint}
                      >
                        <PrintIcon fontSize="20px" />
                      </IconButton>
                      {/* <IconButton
                        sx={{
                          background:
                            "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                          borderRadius: "5px",
                          color: "#050D2E",
                          border: "1px solid #CFD7DF",
                        }}
                        variant="solid"
                        size="small"
                        onClick={handleExport}
                      >
                        <MoreHorizIcon fontSize="10px" />
                      </IconButton> */}
                    </Box>
                  </>
                ) : (
                  <ListItemText>
                    <Typography
                      sx={{
                        color: "#50566E",
                        fontSize: "14px",
                        lineHeight: "16px",
                        width: "266px",
                      }}
                    >
                      {messages.length} Messages
                    </Typography>
                  </ListItemText>
                )}
              </ListItemButton>
            </ListItem>

            <Divider />

            <Grid container sx={{ width: "100%" }}>
              <Grid item xs={1}>
                <Button
                  sx={{
                    width: "100%",
                    minWidth: "0px",
                    backgroundColor: "#D4EDF3",
                    border: "1px solid #85C5D5",
                    color: "#1492AF",
                    height: "98%",
                    borderRadius: "5px 0px 0px 5px",
                  }}
                  onClick={handleToggleFilters}
                >
                  <TuneIcon sx={{ width: "15px" }} />
                  <ArrowDropDownIcon sx={{ width: "15px" }} />
                </Button>
              </Grid>

              <Grid
                item
                xs={11}
                ref={searchFiltersRef}
                sx={{ overflow: "hidden" }}
              >
                <Slide
                  direction="right"
                  in={isFiltersOpen}
                  timeout={700}
                  container={searchFiltersRef.current}
                >
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": {
                        backgroundColor: "#ffffff",
                        borderRadius: "0px 5px 5px 0px",
                        color: "#1C2238",
                        fontSize: ".875rem",
                        "& fieldset": {
                          borderColor: "#D3D8E3",
                        },
                        "&:hover fieldset": {
                          borderColor: "#D3D8E3",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#D3D8E3",
                        },
                      },
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="Search"
                    value={searchFilters}
                    onChange={handleSearchFilters}
                  />
                </Slide>
              </Grid>
            </Grid>

            {/*Filters popper */}
            <Popper
              open={isFiltersOpen}
              anchorEl={anchorEl}
              transition
              placement="bottom-start"
              elevation={2}
            >
              {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={700}>
                  <Paper sx={{ width: "250px", p: 1 }}>
                    <Grid container direction="column">
                      <Grid item>
                        <Typography
                          sx={{
                            color: "#1492AF",
                            fontSize: "10px",
                            fontWeight: 500,
                            marginTop: "10px",
                            marginLeft: "5px",
                            cursor: "pointer",
                          }}
                          onClick={clearAllFilters}
                        >
                          Clear
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          sx={{
                            height: "14px",
                            color: "#8792AB",
                            fontSize: "12px",
                            fontWeight: 500,
                            lineHeight: "13px",
                            marginTop: "10px",
                            marginLeft: "5px",
                          }}
                        >
                          SHOW ONLY MESSAGES WITH..
                        </Typography>
                      </Grid>
                      <Grid item>
                        {categories.map((cat) => {
                          const catFilters = filters.filter(
                            (filter) => filter.categoryLabel === cat
                          );

                          return (
                            <Grid container direction="column" key={cat}>
                              <Grid item container>
                                {/*<Grid item>
                                  <img
                                    src={getFilterIcon(cat)}
                                    alt="filter-icon"
                                    loading="lazy"
                                  />
                                </Grid>*/}
                                <Grid item>
                                  <Typography
                                    sx={{
                                      height: "14px",
                                      color: "#8792AB",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      lineHeight: "13px",
                                      marginTop: "10px",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    {cat}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Grid item>
                                {catFilters.map((filter) => (
                                  <ListItemButton
                                    sx={{
                                      fontSize: "13px",
                                      color: "#050D2E",
                                      fontWeight: 550,
                                      height: "38px",
                                      width: "100%",
                                      ...(checkedFilters.findIndex(
                                        (checkedFilter) =>
                                          checkedFilter.id === filter.id
                                      ) !== -1 && {
                                        backgroundColor: "#d4edf3",
                                      }),
                                    }}
                                    id={filter.id}
                                    onClick={handleToggleFilter}
                                    key={filter.id}
                                  >
                                    <img
                                      src={filter.icon}
                                      loading="lazy"
                                      alt={`${filter.id}-filter-icon`}
                                    />
                                    <Checkbox
                                      icon={
                                        <CheckBoxOutlineBlankIcon
                                          fontSize="small"
                                          sx={{ width: "17px" }}
                                        />
                                      }
                                      checkedIcon={
                                        <CheckBoxIcon
                                          fontSize="small"
                                          sx={{ width: "17px" }}
                                        />
                                      }
                                      edge="start"
                                      checked={
                                        checkedFilters.findIndex(
                                          (checkedFilter) =>
                                            checkedFilter.id === filter.id
                                        ) !== -1
                                      }
                                      tabIndex={-1}
                                      disableRipple
                                      size="small"
                                      sx={{
                                        height: "28px",
                                        width: "28px",
                                        "&.Mui-checked": {
                                          color: "#1492AF",
                                        },
                                        pl: 4,
                                      }}
                                      id={filter.id}
                                    />
                                    {filter.label}
                                  </ListItemButton>
                                ))}
                              </Grid>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>
                  </Paper>
                </Fade>
              )}
            </Popper>

            <Divider />
            {messages.length ? (
              messages.map((message) => {
                const labelId = `checkbox-list-label-${message.header.referenceNumber}`;

                return (
                  <div key={message.header.referenceNumber}>
                    <ListItem disablePadding>
                      <ListItemButton
                        role={undefined}
                        id={message.header.referenceNumber}
                        onClick={handleSelect}
                        dense
                        sx={{
                          minHeight: "80px",
                          width: "100%",
                          backgroundColor:
                            currentReferenceNumber ===
                            message.header.referenceNumber
                              ? "#E0F2F6"
                              : "#F8FAFB",
                          paddingLeft: "22px",
                        }}
                      >
                        <Grid container direction="column" spacing={0}>
                          <Grid item>
                            <Grid container>
                              <Grid item>
                                <Checkbox
                                  edge="start"
                                  checked={
                                    checked.findIndex(
                                      (messageObj) =>
                                        messageObj.header.referenceNumber ===
                                        message.header.referenceNumber
                                    ) !== -1
                                  }
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                  size="small"
                                  sx={{
                                    "&.Mui-checked": {
                                      color: "#1492AF",
                                    },
                                  }}
                                  id={message.header.referenceNumber}
                                  onClick={handleToggle}
                                />
                              </Grid>
                              <Grid item>
                                <Typography
                                  sx={{
                                    color: "#50566E",
                                    fontSize: "14px",
                                    lineHeight: "16px",
                                    width: "270px",
                                    marginTop: "10px",
                                  }}
                                >
                                  {`${
                                    message.header.referenceNumber
                                      ? message.header.referenceNumber
                                      : ""
                                  } ${
                                    message.header.currency
                                      ? "-->" + message.header.currency + "#"
                                      : ""
                                  }    ${
                                    message.header.amount
                                      ? message.header.amount + "#"
                                      : ""
                                  } `}
                                  {`${
                                    message.header.accountNumber
                                      ? "Account N " +
                                        message.header.accountNumber
                                      : ""
                                  }`}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>

                          {/*Message Icons (filters) */}
                          <Grid item>
                            <MessageIcons
                              filters={message.header.filters}
                              country={message.header.country}
                            />
                          </Grid>
                        </Grid>
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                  </div>
                );
              })
            ) : (
              <Typography
                sx={{
                  margin: "auto",
                  width: "40%",
                  paddingTop: "20%",
                  color: "#50566E",
                  fontWeight: 550,
                  fontSize: ".875rem",
                  opacity: 0.85,
                }}
              >
                No messages found
              </Typography>
            )}
          </>
        )}
      </List>
    </div>
  );
};

export default SelectedMessages;
